import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-084ade1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-kanban-card-view-settings-dropdown" }
const _hoisted_2 = { class: "task-kanban-card-view-settings-dropdown__target" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-kanban-card-view-settings-dropdown__target-text" }, "Настройка карточек", -1))
const _hoisted_4 = { class: "task-kanban-card-view-settings-dropdown__option-list" }

import { TirCheckbox, TirPmOptionList } from 'tir-components';
import { ChevronDownIcon, Cog8ToothIcon } from 'tir-style-system/icons/outline';
import { computed, PropType } from 'vue';
import { TaskViewElementEnum } from '../enums';
import { TirPmScrollbar } from 'tir-components';


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskKanbanCardViewSettingsDropdown',
  props: {
  modelValue: {
    type: Array as PropType<Array<TaskViewElementEnum>>,
    required: true,
  },
  /**Заблокиованные чекбоксы */
  disabledCheckboxes: {
    type: Array as PropType<Array<TaskViewElementEnum>>,
    default: [],
  },
  /**Скрытые чекбоксы */
  hiddenCheckboxes: {
    type: Array as PropType<Array<TaskViewElementEnum>>,
    default: [],
  },
  /**Отображение сортировки и группировки */
  isSortingAndGroupingHidden: { type: Boolean as PropType<boolean> },
  /**Скрыть статус для настройки таблицы */
  hideStatus: { type: Boolean, default: false },
},
  emits: ["update:modelValue", "checkOpenOptionsViewSettings"],
  setup(__props, { emit: emits }) {

const props = __props;





const options = [
  {
    ElementType: TaskViewElementEnum.Author,
    Text: 'Автор',
  },
  {
    ElementType: TaskViewElementEnum.Queue,
    Text: 'Очередь',
  },
  {
    ElementType: TaskViewElementEnum.Performers,
    Text: 'Исполнители',
  },
  {
    ElementType: TaskViewElementEnum.Observers,
    Text: 'Наблюдатели',
  },
  {
    ElementType: TaskViewElementEnum.Status,
    Text: 'Статус',
  },
  {
    ElementType: TaskViewElementEnum.Priority,
    Text: 'Приоритет',
  },
  {
    ElementType: TaskViewElementEnum.Tags,
    Text: 'Теги',
  },
  {
    ElementType: TaskViewElementEnum.Type,
    Text: 'Тип задачи',
  },
  {
    ElementType: TaskViewElementEnum.DateCreate,
    Text: 'Дата создания',
  },
  {
    ElementType: TaskViewElementEnum.EstimateTime,
    Text: 'Оценка времени',
  },
  {
    ElementType: TaskViewElementEnum.WorkTime,
    Text: 'Время работы',
  },
  {
    ElementType: TaskViewElementEnum.Difficulty,
    Text: 'Сложность',
  },
  {
    ElementType: TaskViewElementEnum.Deadline,
    Text: 'Дедлайн',
  },
];

let optionsTasksOverview = [
  {
    ElementType: TaskViewElementEnum.Status,
    Text: 'Статус',
  },
  {
    ElementType: TaskViewElementEnum.Priority,
    Text: 'Приоритет',
  },
  {
    ElementType: TaskViewElementEnum.EstimateTime,
    Text: 't (оценка)',
  },
  {
    ElementType: TaskViewElementEnum.WorkTime,
    Text: 't (затрачено)',
  },
  {
    ElementType: TaskViewElementEnum.Difficulty,
    Text: 'Сложность',
  },
];

/**Отфильтрованный список настроек карточки */
const filteredOptionsTasksOverview = computed(() => {
  if (props.hideStatus) {
    return optionsTasksOverview.filter(
      (option) => option.ElementType !== TaskViewElementEnum.Status,
    );
  } else {
    return optionsTasksOverview;
  }
});
/**Опции для настройки */
const optionsSettings = computed(() =>
  (props.isSortingAndGroupingHidden ? filteredOptionsTasksOverview.value : options).filter(
    (option) => !props.hiddenCheckboxes.includes(option.ElementType),
  ),
);

/**Проверка активности чекбокса */
const checkActive = (type: TaskViewElementEnum) => {
  return props.modelValue.includes(type);
};
/**
 * * Выбрать опцию
 * @param elementType
 */
const toggleOption = (elementType: TaskViewElementEnum) => {
  if (props.modelValue.includes(elementType))
    emits(
      "update:modelValue",
      props.modelValue.filter((_elementType) => _elementType !== elementType),
    );
  else emits("update:modelValue", [...props.modelValue, elementType]);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmOptionList), {
      width: 280,
      onCheckOpenOptions: _cache[0] || (_cache[0] = ($event: any) => (emits('checkOpenOptionsViewSettings', $event)))
    }, {
      optionListTarget: _withCtx(({ isOpened }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Cog8ToothIcon), { class: "task-kanban-card-view-settings-dropdown__target-icon" }),
          _hoisted_3,
          _createVNode(_unref(ChevronDownIcon), {
            class: _normalizeClass([
              'task-kanban-card-view-settings-dropdown__target-chevron',
              { 'is-opened': isOpened },
            ])
          }, null, 8, ["class"])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_unref(TirPmScrollbar), {
          class: "scrollbar",
          "show-on-hover": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsSettings.value, (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option.ElementType
                }, [
                  _createVNode(_unref(TirCheckbox), {
                    class: _normalizeClass([
                  'task-kanban-card-view-settings-dropdown__option',
                  { 'is-disabled': __props.disabledCheckboxes.includes(option.ElementType) },
                ]),
                    "is-disabled": __props.disabledCheckboxes.includes(option.ElementType),
                    "model-value": checkActive(option.ElementType),
                    "onUpdate:modelValue": ($event: any) => (toggleOption(option.ElementType, $event))
                  }, {
                    mainSign: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option.Text), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "is-disabled", "model-value", "onUpdate:modelValue"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})